// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__yFszq","head":"Table_head__fPcvu","col":"Table_col__2Jd2C"};